import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["checkAndCompleteTask", "children", "task"];
import { installExtension } from 'getting-started-shared-tasks/taskNames';
import OpenModalButton from '../../button/OpenModalButton';
import ManualDetectedTaskComponent from './ManualDetectedTaskComponent';
import { useTracker } from '../../../hooks/tracking';
import { jsx as _jsx } from "react/jsx-runtime";
const InstallExtensionButton = _ref => {
  let {
      checkAndCompleteTask,
      children,
      task
    } = _ref,
    passThroughProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    tracker
  } = useTracker();
  return /*#__PURE__*/_jsx(OpenModalButton, Object.assign({
    onModalClose: () => void checkAndCompleteTask(installExtension),
    text: children
  }, passThroughProps, {
    children: /*#__PURE__*/_jsx(ManualDetectedTaskComponent, {
      task: task,
      tracker: tracker
    })
  }));
};
export default InstallExtensionButton;